import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportType, DBImportPreview } from '@/types/import';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (importType: string) => {
  if (!importType) {
    throw new Error('`importType` is required');
  }
};

type RequestParams = {
  importType: DBImportType;
};

type Response = DBImportPreview[];

export const getImportPreviews = async (
  scope: RequestScope,
  { importType }: RequestParams,
  requestOptions: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(importType);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`import_preview/${importType}`, requestOptions);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
